import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Breadcrumb, BreadcrumbService } from './components/pages/services/breacrumb.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [
    Location,
    { provide: LocationStrategy, useClass: PathLocationStrategy }
  ],
  standalone: false
})
export class AppComponent implements OnInit {

  breadcrumbs: Breadcrumb[] = [];

  constructor(
    private titleService: Title,
    private breadcrumbService: BreadcrumbService
  ) {}

  ngOnInit(): void {
    this.breadcrumbService.breadcrumbs$.subscribe(breadcrumbs => {
      this.breadcrumbs = breadcrumbs;
      this.titleService.setTitle(this.createTitle(breadcrumbs));
    });
  }

  onActivate(_event: any) {
    window.scroll(0, 0);
  }

  private createTitle(breadcrumbs: Breadcrumb[]) {
    const baseTitle = "Curium";
    if (!breadcrumbs.length) return baseTitle;

    const routeTitle = breadcrumbs.map(b => b.label).join(' | ');
    return `${baseTitle} | ${routeTitle}`;
  }
}
